<template>
    <v-card :id="id" color="grey lighten-2" class="mt-3">
        <psi-card-heading
            :headingTitle="title"
            :icon="icon"
            :heading-color="headingColor"
        >
          <v-switch
                v-if="can('public-records.exclude')"
                class="mt-0 mr-2"
                hide-details
                dark
                :true-value="true"
                :input-value="removeExclude"
                label="Show Student Excluded Records"
                color="accent lighten-2"
                @change="onRemoveExclude"
            ></v-switch>
            <v-switch
                v-if="can('public-record-limits.remove')"
                class="mt-0"
                hide-details
                dark
                :true-value="true"
                :input-value="removeLimits"
                label="Show Filtered Records"
                color="accent lighten-2"
                @change="onRemoveLimits"
            ></v-switch>
        </psi-card-heading>
        <v-alert  border="top" :text="true" color="grey-2" class="ma-4">
            THE PURPOSE OF THIS TENANT SAMPLE REPORT IS FOR EDUCATIONAL PURPOSES ONLY.  Excluding criminal or eviction records will remove them from your Tenant Sample Report.  If you have questions, please contact your Instructor. 
        </v-alert>

        <v-card-text>
            <div class="d-flex align-center">
                <h3 class="my-2 mr-3">Crime Records</h3>
                <v-chip
                    class="my-2"
                    color="accent"
                    v-if="crimeRecordCount > 0"
                    >{{ crimeRecordCount }}</v-chip
                >
            </div>
            <v-row v-if="crimeRecordCount === 0">
                <v-col cols="12">
                    <v-alert  outlined icon="mdi-scale-balance">
                        No Crime Records Found
                    </v-alert>
                </v-col>
            </v-row>
            <v-row v-else no-gutters>
                <template v-for="(charge, index) in charges">
                    <v-col cols="6" :key="index">
                        <screen-charge
                            class="mx-2 my-2 py-2"
                            :charge="charge"
                            mode="screen"
                            @exclude="onExcludeCrime"
                        ></screen-charge>
                    </v-col>
                </template>
            </v-row>
            <div class="d-flex align-center">
                <h3 class="mt-2 mb-4">Eviction Records</h3>
                <v-chip
                    class="my-2 ml-2"
                    color="accent"
                    v-if="evictionRecordCount > 0"
                    >{{ evictionRecordCount }}</v-chip
                >
            </div>
            <v-row v-if="evictionRecordCount === 0">
                <v-col cols="12">
                    <v-alert border="top" outlined icon="mdi-scale-balance">
                        No Eviction Records Found
                    </v-alert>
                </v-col>
            </v-row>
            <screen-evictions-wrapper
                v-if="evictionRecordCount > 0"
                :evictions="mappedEvictions"
                mode="screen"
                @exclude="onExcludeEviction"
            ></screen-evictions-wrapper>
        </v-card-text>
    </v-card>
</template>
<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

import WithCrimeRecords from '@components/screen/mixins/WithCrimeRecords';

export default {
    name: "screening-process-public-records",
    components: {
        ScreenCharge: () =>
            import("@components/screen/components/Search/ScreenCharge"),
        ScreenEvictionsWrapper: () =>
            import(
                "@components/screen/components/Search/ScreenEvictionsWrapper"
            ),
    },
    mixins: [WithCrimeRecords],
    props: {
        id: {
            type: String,
            required: false,
            default: "screening-crime",
        },
        headingColor: {
            type: String,
            required: false,
            default: "primary",
        },
        title: {
            type: String,
            required: false,
            default: "Blank",
        },
        icon: {
            type: String,
            required: false,
            default: "mdi-scale-balance",
        },
        height: {
            type: [String, Number],
            required: false,
            default: 600,
        },
        maxHeight: {
            type: Number,
            required: false,
            default: 200,
        },
        summary: {
            type: Object,
            required: true,
        },
        evictions: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
        crimes: {
            type: Array,
            required: false,
            default: () => {},
        },
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters("Screens", ["removeLimits","removeExclude"]),
        crimeRecordCount() {
            return this.records.length;
        },
        evictionRecordCount() {
            return this.evictionRecords.length;
        },
    },
    methods: {
        ...mapActions("Screens", ["getCurrentScreen","updateSearchCrime","updateSearchEviction"]),
        ...mapMutations("Screens", ["SET_REMOVE_LIMITS","SET_REMOVE_EXCLUDE"]),
        onRemoveLimits(value) {
            this.SET_REMOVE_LIMITS(value);
            this.getCurrentScreen();
        },
        onRemoveExclude(value) {
            this.SET_REMOVE_EXCLUDE(value);
            this.getCurrentScreen();
        },
        onExcludeCrime(crime_id) {
            this.updateSearchCrime(crime_id);
        },
        onExcludeEviction(eviction_id) {
            this.updateSearchEviction(eviction_id);
        },
        
    },
    created() {
        this.records = this.crimes;
        this.evictionRecords = this.evictions;
    },
};
</script>

<style scoped>
</style>